import axios from "axios";
import { useQuery } from "react-query";
import { useInView } from "react-intersection-observer";

export const useAggrMetricsAcrossDimensions = ({
    contentType,
    activeFilters = [],
    dimensions,
    metrics,
    findQuery,
    queryOptions = {},
    returnMetadata = false,
    includePartialDimensions = false,
    includeZeroCounts = false,
    enableVisibilityFetching = false,
  }) => {

    const { ref, inView } = useInView({
      triggerOnce: true,
      skip: !enableVisibilityFetching
    });

    const body = {
        contentType,
        dimensions,
        metrics,
        findQuery,
        activeFilters,
        returnMetadata,
        includePartialDimensions,
        includeZeroCounts,
    }
  
    const endpoint = `/api/insightMatrix/aggrMetricsAcrossDimensions`

    const serializedBody = JSON.stringify(body);

    const shouldFetch = enableVisibilityFetching ? inView : true;
  
    // Keyed on the request alone: two widgets asking the same question share
    // one request and one cache entry (the server only ever sees the body).
    const result = useQuery({
      queryKey: ["useAggrMetricsAcrossDimensions", serializedBody],
      queryFn: () =>
        axios
          .post(endpoint, body, {
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((data) => data.data),
      ...queryOptions,
      enabled: (queryOptions.enabled !== false) && shouldFetch,
    });

    const isWaitingForVisibility = enableVisibilityFetching && !inView;
    const effectiveStatus = isWaitingForVisibility ? "loading" : result.status;

    return {
      ...result,
      status: effectiveStatus,
      ref: enableVisibilityFetching ? ref : undefined,
    };
  };
